export default {
    name: 'typeproducts',
    component: () => import(/* webpackChunkName: "typeproducts-Layout" */ '@/modules/typeproducts/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.typeproducts.index',
            component: () => import(/* webpackChunkName: "typeproducts-index" */ '@/modules/typeproducts/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.typeproducts.create',
            component: () => import(/* webpackChunkName: "typeproducts-create" */ '@/modules/typeproducts/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.typeproducts.edit',
            component: () => import(/* webpackChunkName: "typeproducts-edit" */ '@/modules/typeproducts/views/Edit'),
        },
    ]
}